<template lang="pug">

  #inviteByEmailContainer

    h3.sosInvitePageTitle
      | INFORME OS E-MAILS DA SUA EQUIPE

    h4.sosInvitePageDescription
      | Você poderá criar uma escala mesmo que os integrantes não estejam cadastrados.
      br
      | Eles poderão acessar suas contas através de uma senha pré-definida.

    table.sosInvitationList

      thead

        tr
          th(width="354") Nome completo
          th(width="354") E-mail
          th(width="20") &nbsp;

      tbody

        tr(v-for="(convidado, userIndex) in convidados" :key="`user_to_invite_${userIndex}`")
          td
            .searchBlock(:class="{ 'searchBlock--error': convidado.status.code === 0 && convidado.status.data.length > 0 }")
              input(v-model="convidado.nome" type="text" maxlength="64" placeholder="Nome").searchField
          td
            .searchBlock(:class="{ 'searchBlock--error': convidado.status.code === 0 && convidado.status.data.length > 0 }")
              input(v-model="convidado.email" type="text" maxlength="64" placeholder="E-mail").searchField

            .statuses(v-if="convidado.status.code === 2 && convidado.status.data.length > 0")
              p(v-for="(statuses, statusesIndex) in convidado.status.data" :key="`user_${userIndex}_statuses_${statusesIndex}`")
                | {{ statuses }}

            .successes(v-if="convidado.status.code === 1 && convidado.status.data.length > 0")
              p(v-for="(success, successIndex) in convidado.status.data" :key="`user_${userIndex}_success_${successIndex}`")
                | {{ success }}

            .errors(v-if="convidado.status.code === 0 && convidado.status.data.length > 0")
              p(v-for="(error, errorIndex) in convidado.status.data" :key="`user_${userIndex}_error_${errorIndex}`")
                | {{ error }}
          td
            button(@click.prevent="guestDelete(userIndex)" :disabled="convidados.length <= 1 || convidado.status.code === 1 || convidado.status.code === 2").sosInvivationDelete
              i(aria-hidden="true").v-icon.notranslate.mdi.mdi-minus

      tfoot

        tr
          td
            button(@click.prevent="guestAdd()" :disabled="maxInvitePerRequest <= 0 || disableAddUsers").sosInvivationAdd
              i(aria-hidden="true").v-icon.notranslate.mdi.mdi-plus
              span.sosInvitationAddText {{ maxInvitePerRequest > 0 ? `Adicionar mais ${maxInvitePerRequest}` : 'Adicionar' }}

          td.sosInvitationListCounter
            span {{ `${this.convidados.length} de 20` }}

          td
            //-

    .sosInvitationListActions
      sos-button(
        @buttonClick="sendInvites()"
        size="medium"
        buttonIcon="mdi-share"
        buttonIconSize="16"
        color="success"
        buttonLabel="Convidar"
        :loading="loading"
        :disabled="disableInviteButton"
      )

      sos-button(
        v-if="disableAddUsers"
        @buttonClick="finish()"
        size="medium"
        buttonIcon="mdi-exit-to-app"
        buttonIconSize="16"
        color="purple"
        buttonLabel="Concluir"
      ).ml-1

    modal-new-users-default-password(ref="defaultPasswordModal" @close="onDefaultPasswordModalClose")

</template>

<script>

  import { apiGetCurrentUser, apiGetUserIdByEmail } from '@/services/firebase'

  import RegexMixin from '@/mixins/regex.mixin'
  import StringMixin from '@/mixins/string.mixin'

  import SosButton from '@/components/SosButton'
  import ModalNewUsersDefaultPassword from './ModalNewUsersDefaultPassword'

  // import { apiUserExists } from '@/services/users'
  import { apiAddUserToGroup, apiCreateUser } from '@/services/users'
  import { firebaseErrorMessages, translateAuthError } from '@/functions'

  //
  //
  //

  const removeAccents = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

  // Replace non-alphanumeric characters with hyphens AND Remove leading and trailing hyphens
  const convertToSlug = text => removeAccents(text).toLowerCase().replace(/[^a-z0-9]+/g, '').replace(/^-+|-+$/g, '')

  //
  //
  //

  export default {
    name: 'SendByEmail',

    components: {
      'modal-new-users-default-password': ModalNewUsersDefaultPassword,
      'sos-button': SosButton,
    },

    mixins: [RegexMixin, StringMixin],

    props: {
      groupID: {
        type: String,
        required: true,
      },
      groupName: {
        type: String,
        required: true,
      },
    },

    data: () => ({
      loading: false,

      myselfEmail: '',

      convidados: [
        { nome: '', email: '', status: { code: null, data: [] } },
        { nome: '', email: '', status: { code: null, data: [] } },
        { nome: '', email: '', status: { code: null, data: [] } },
        { nome: '', email: '', status: { code: null, data: [] } },
        { nome: '', email: '', status: { code: null, data: [] } },
      ],
    }),

    computed: {
      maxInvitePerRequest () {
        return (20 - this.convidados.length) > 5 ? 5 : (20 - this.convidados.length)
      },

      disableInviteButton () {
        const usuariosStandby = []
        const usuariosValidos = []
        const usuariosValidosComErros = []
        const usuariosValidosBemSucedidos = []

        for (var i = 0; i < this.convidados.length; ++i)
        {
          const userName = String(this.convidados[i].nome).trim()
          const userEmail = String(this.convidados[i].email).toLowerCase().trim()

          if (userEmail.length > 0) {
            usuariosValidos.push(this.convidados[i])

            if (userName.length > 0 && this.convidados[i].status.code === null) usuariosStandby.push(this.convidados[i])
            if (userName.length > 0 && this.convidados[i].status.code === 0) usuariosValidosComErros.push(this.convidados[i])
            if (userName.length > 0 && this.convidados[i].status.code === 1) usuariosValidosBemSucedidos.push(this.convidados[i])
          }
        }

        return (
          usuariosStandby.length === 0 &&
          (
            usuariosValidos.length === 0 ||
            usuariosValidosComErros.length === 0 ||
            (
              usuariosValidosBemSucedidos.length > 0 &&
              usuariosValidosComErros.length === 0
            )
          )
        )
      },

      disableAddUsers () {
        const usuariosValidosComErros = []
        const usuariosValidosBemSucedidos = []

        for (var i = 0; i < this.convidados.length; ++i)
        {
          const userName = String(this.convidados[i].nome).trim()
          const userEmail = String(this.convidados[i].email).toLowerCase().trim()

          if (userEmail.length > 0) {
            if (userName.length > 0 && this.convidados[i].status.code === 0) usuariosValidosComErros.push(this.convidados[i])
            if (userName.length > 0 && this.convidados[i].status.code === 1) usuariosValidosBemSucedidos.push(this.convidados[i])
          }
        }

        return usuariosValidosBemSucedidos.length > 0 && usuariosValidosComErros.length === 0
      },
    },

    mounted () {
      const { email: myselfEmail } = apiGetCurrentUser()
      this.myselfEmail = myselfEmail
    },

    beforeDestroy () {
      // LIMPAR VARIÁVEIS AO SAIR DA TELA
      this.clear()
    },

    methods: {
      //
      // .
      //

      finish () {
        this.$router.push(`/admin/grupos/${this.groupID}/escalas`)
      },

      //
      // LIMPAR VARIÁVEIS
      //

      clear () {
        this.loading = false

        this.myselfEmail = ''

        this.convidados = [
          { nome: '', email: '', status: { code: null, data: [] } },
          { nome: '', email: '', status: { code: null, data: [] } },
          { nome: '', email: '', status: { code: null, data: [] } },
          { nome: '', email: '', status: { code: null, data: [] } },
          { nome: '', email: '', status: { code: null, data: [] } },
        ]

        delete this.loading
        delete this.myselfEmail
        delete this.convidados
      },

      //
      //
      //

      guestDelete (guestIndex) {
        if (this.convidados.length <= 1) return false

        // this.convidados.unshift(
        this.convidados = this.convidados.filter((item, index) => (index !== guestIndex))
      },

      //
      //
      //

      guestAdd () {
        const maxInvitePerRequest = (20 - this.convidados.length) > 5 ? 5 : (20 - this.convidados.length)

        // [24/01/25] console.log('::: GUEST ADD:', maxInvitePerRequest)

        for (let i = 0; i < maxInvitePerRequest; i++) {
          this.convidados.push({ nome: '', email: '', status: { code: null, data: [] } })
        }
      },

      //
      //
      //

      async onDefaultPasswordModalClose (userPassword)
      {
        // [24/01/25] console.log('::: Output:', !!userPassword === false ? 'Cancelado' : userPassword)

        //
        // Não permite click durante a execução
        //

        if (this.loading) return false

        //
        // Não processa integrantes após cancelamento
        //

        if (!!userPassword === false) return false

        //
        // Mostra o loader
        //

        this.loading = true

        //
        //
        //

        for (var index = 0; index < this.convidados.length; ++index)
        {
          const userName = String(this.convidados[index].nome).trim()
          const userEmail = String(this.convidados[index].email).toLowerCase().trim()

          //
          // Pula e-mail vazio
          //

          // if (userEmail.length === 0) return false
          if (userEmail.length > 0)
          {
            //
            // Validação
            //

            const isInvalidName = userName.length === 0
            const isMe = userEmail === this.myselfEmail
            const isEmailInvalid = !this.isValidEmail(userEmail)
            // Jesus: Testar melhor...
            const isDuplicated = this.convidados.reduce((count, item) => this.isValidEmail(item.email) && item.email.toLowerCase() === userEmail ? count + 1 : count, 0) > 1

            this.convidados[index].status.data = []

            if (isInvalidName) this.convidados[index].status.data.push('Informe o nome.')
            if (isMe) this.convidados[index].status.data.push('Você não pode adicionar a si mesmo.')
            if (isEmailInvalid) this.convidados[index].status.data.push('Este email é inválido.')
            if (isDuplicated) this.convidados[index].status.data.push('Este e-mail já existe na lista.')

            if (this.convidados[index].status.data.length > 0) return this.convidados[index]

            //
            // Carregando
            //

            this.convidados[index].status.code = 2
            this.convidados[index].status.data = ['Buscando...']

            //
            // VERIFICA SE ESTE E-MAIL EXISTE NO FIREBASE AUTHENTICATION
            //

            const check = await apiGetUserIdByEmail(userEmail)

            // [24/01/25] console.log(`[Grupo ${this.groupID}] [${userEmail}] sendInvites > LEITURA DO USUÁRIO:`, check)

            //
            // HOUVE ALGUM ERRO AO LER USUÁRIO
            //

            if (
              check.code === 0 &&
              (
                !Object.prototype.hasOwnProperty.call(check.data, 'code') ||
                (
                  Object.prototype.hasOwnProperty.call(check.data, 'code') &&
                  check.data.code !== 'auth/user-not-found'
                )
              )
            )
            {
              this.convidados[index].status.code = 0

              this.convidados[index].status.data = (
                (
                  Object.prototype.hasOwnProperty.call(check.data, 'code') &&
                  Object.prototype.hasOwnProperty.call(check.data, 'data') &&
                  check.data.code !== 'auth/user-not-found'
                ) ? (
                  ['Não foi possível processar: ' + check.data.data]
                ) : (
                  ['Não foi possível processar']
                )
              )

              // return this.convidados[index]
            }

            //
            // ADICIONA USUÁRIO NO GRUPO
            //

            else if (check.code === 1)
            {
              this.convidados[index].status.data = ['Convidando...']

              const userID = String(check.data)

              const addUserResult = await new Promise(resolve => { apiAddUserToGroup(userID, this.groupID, addResponse => resolve(addResponse)) })

              // [24/01/25] console.log(`::: [Grupo ${this.groupID}] [${userEmail}] sendInvites > STATUS DA INCLUSÃO DO USUÁRIO:`, addUserResult)

              this.convidados[index].status.code = !!addUserResult.error === true ? 0 : 1
              this.convidados[index].status.data = [!!addUserResult.error === true ? (addUserResult.error.code ? firebaseErrorMessages(addUserResult.error.code) : addUserResult.error) : 'Foi incluído no grupo com sucesso!']

              // return this.convidados[index]
            }

            //
            // CRIA USUÁRIO E ADICIONA NO GRUPO
            //

            else if (check.code === 0 && Object.prototype.hasOwnProperty.call(check.data, 'code') && check.data.code === 'auth/user-not-found')
            {
              this.convidados[index].status.data = ['Cadastrando e convidando...']

              const request = await apiCreateUser({ origin: 'WEB', name: userName, email: userEmail, password: userPassword, phone: '', crm: '', groupID: this.groupID })

              // [24/01/25] console.log(`::: [Grupo ${this.groupID}] [${userEmail}] sendInvites > STATUS DO CADASTRAMENTO:`, request.message, request.error)

              //
              //
              //

              this.convidados[index].status.code = request.httpCode === 201 ? 1 : 0

              this.convidados[index].status.data = [
                request.httpCode === 201 ? 'Foi cadastrado e incluído no grupo com sucesso!' : request.message,
              ]

              // return this.convidados[index]
            }

            //
            //
            //

            // else
            // {
              // return this.convidados[index]
            // }
          }
        }

        //
        // Mostra o loader
        //

        this.loading = false
      },

      //
      //
      //

      sendInvites ()
      {
        //
        // Não permite click durante a execução

        if (this.loading) return false

        //
        // Debug

        // [24/01/25] console.log('::: SEND INVITES > myselfEmail:', this.myselfEmail)

        //
        // Validando usuários

        let hasErrors = false

        for (var i = 0; i < this.convidados.length; ++i)
        {
          const userName = String(this.convidados[i].nome).trim()
          const userEmail = String(this.convidados[i].email).toLowerCase().trim()

          if (userEmail.length === 0)
          {
            this.convidados[i].status.code = null
            this.convidados[i].status.data = []
          }
          else
          {
            const isInvalidName = userName.length === 0
            const isMe = userEmail === this.myselfEmail
            const isEmailInvalid = !this.isValidEmail(userEmail)
            // Jesus: Testar melhor...
            const isDuplicated = this.convidados.reduce((count, item) => this.isValidEmail(item.email) && item.email.toLowerCase() === userEmail ? count + 1 : count, 0) > 1

            this.convidados[i].status.data = []

            if (isInvalidName) this.convidados[i].status.data.push('Informe o nome.')
            if (isMe) this.convidados[i].status.data.push('Você não pode adicionar a si mesmo.')
            if (isEmailInvalid) this.convidados[i].status.data.push('Este email é inválido.')
            if (isDuplicated) this.convidados[i].status.data.push('Este e-mail já existe na lista.')

            /* if (this.convidados[i].status.data.length === 0) {
              // [24/01/25] console.log(`::: SEND INVITES > ${userEmail}:`, userName)
              convidar.push(this.convidados[i])
            } else {
              hasErrors = true
            } */

            if (this.convidados[i].status.data.length > 0) {
              this.convidados[i].status.code = 0
              hasErrors = true
            }
          }
        }

        if (!hasErrors)
        {
          let defaultPassword = this.groupName !== '[SEM NOME]' && this.groupName.length > 6 ? this.groupName : ''

          const withoutAccents = removeAccents(defaultPassword)

          // Remove non-alphanumeric characters
          const alphanumericOnly = withoutAccents.replace(/[^a-z0-9]+/gi, '')

          // Check if the result is empty (only numbers or special characters)
          defaultPassword = alphanumericOnly.length > 0 ? convertToSlug(defaultPassword) : '1q2w3e4r'

          this.$refs.defaultPasswordModal.open(defaultPassword)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

  #inviteByEmailContainer {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    margin-bottom: 15px;
    padding: 45px 20px 35px 20px;
    border-radius: 4px;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    background-color: #FFFFFF;

    color: rgba(0, 0, 0, 0.87);
  }

  .sosInvitePageTitle {
    font-size: 25px;
    font-weight: 400;
    text-align: center;

    @media(max-width: 960px){
      font-size: 23px;
    }
    @media(max-width: 600px){
      font-size: 25px;
    }
  }

  .sosInvitePageDescription {
    max-width: 768px;
    margin: 20px auto 35px auto;

    font-size: 18px;
    line-height: 26px;
    font-weight: 400;
    text-align: center;
  }

  //

  .sosInvitationList {
    display: table;
    width: 100%;
    max-width: 768px;
    margin: 0 auto;
    border-collapse: separate;
    border-spacing: 10px;

    text-align: left;

    td {
      vertical-align: top;
    }
  }

  //

  .searchField {
    width: 100%;
    // max-width: 320px;
    height: 100%;
    background-color: #ffffff;
    padding: 0 20px;
    // padding: 0 20px 0 40px;
    border-radius: 10px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(70, 40, 40, 0.25);
    outline: 0;
    // box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.25);
    font-size: 15px;
    &:disabled {
      background-color: #CCCCCC;
    }
  }

  .searchBlock {
    position: relative;
    display: block;
    width: 100%;
    // max-width: 320px;
    height: 40px;

    &.searchBlock--error {
      .searchField {
        border-color: indianred;

        color: darkred;
      }
    }
  }

  .statuses,
  .successes,
  .errors {
    margin-top: 5px;

    p {
      margin: 0;

      font-size: 14px;
      line-height: 14px;
    }
  }

  .statuses p {
    color: mediumslateblue;
  }

  .successes p {
    color: darkgreen;
  }

  .errors p {
    color: indianred;
  }

  //

  .sosInvivationDelete {
    position: relative;

    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    margin-top: 10px;
    outline: 0;
    border: 0;

    color: indianred;

    &[disabled] {
      opacity: 0.5;
    }
  }

  .sosInvivationDelete .v-icon {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    width: 20px;
    height: 20px;
    margin: auto;
    padding: 9px 0;
    border: 1px solid indianred;
    border-radius: 4px;

    font-size: 16px;
    line-height: 0;
  }

  //

  .sosInvivationAdd .v-icon {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 20px;
    height: 20px;
    margin: auto 0;
    font-size: 16px;
    border: 1px solid mediumslateblue;
    border-radius: 4px;
    line-height: 0;
    padding: 9px 0;
  }

  .sosInvivationAdd {
    position: relative;

    display: inline-block;
    vertical-align: middle;
    outline: 0;
    border: 0;

    color: mediumslateblue;

    &[disabled] {
      opacity: 0.5;

      color: #777777;

      .v-icon {
        border: 1px solid #777777;
      }
    }
  }

  //

  .sosInvitationAddText {
    display: inline-block;
    vertical-align: baseline;
    padding-left: 25px;
    font-size: 16px;
    line-height: 20px;
  }

  //

  .sosInvitationListCounter {
    color: steelblue;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: right;
  }

  //

  .sosInvitationListActions {
    max-width: 768px;
    margin: 0 auto;
    padding: 10px;

    text-align: right;
  }

</style>
